import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAssetMobileDevice = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <rect
      width={8.236}
      height={12.236}
      x={6}
      y={4}
      fill="url(#Asset_mobile_device_svg__a)"
      fillOpacity={0.5}
      opacity={0.9}
      rx={2.047}
    />
    <path
      fill="url(#Asset_mobile_device_svg__b)"
      fillOpacity={0.5}
      d="M13.598 5.978a.35.35 0 0 1 .638.2v8.058a2 2 0 0 1-2 2H7.725a.65.65 0 0 1-.534-1.02z"
      opacity={0.56}
    />
    <path
      fill="url(#Asset_mobile_device_svg__c)"
      fillOpacity={0.4}
      d="M6 12.694h8.237v1.496c0 1.13-.916 2.046-2.046 2.046H8.046A2.046 2.046 0 0 1 6 14.19z"
    />
    <circle
      cx={10.236}
      cy={14.366}
      r={0.706}
      fill="var(--dataviz-color-sequential-blue-scale05)"
    />
    <defs>
      <linearGradient
        id="Asset_mobile_device_svg__a"
        x1={12.691}
        x2={2.394}
        y1={12.986}
        y2={12.842}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale06)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
      <linearGradient
        id="Asset_mobile_device_svg__b"
        x1={12.782}
        x2={6.297}
        y1={13.267}
        y2={13.321}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale01)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
      <linearGradient
        id="Asset_mobile_device_svg__c"
        x1={12.692}
        x2={2.416}
        y1={15.295}
        y2={14.797}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale06)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAssetMobileDevice;
